import { createFileRoute } from "@tanstack/react-router";
import { ProjektassistancePage, projektassistanceHead } from "@/pages/ProjektassistancePage";

export const Route = createFileRoute("/en/project-assistance")({
  head: () => projektassistanceHead("en"),
  component: () => <ProjektassistancePage locale="en" />,
});
